import { render, staticRenderFns } from "./CaratteristicheNew.vue?vue&type=template&id=37f8493e&scoped=true&"
import script from "./CaratteristicheNew.vue?vue&type=script&lang=js&"
export * from "./CaratteristicheNew.vue?vue&type=script&lang=js&"
import style0 from "./CaratteristicheNew.vue?vue&type=style&index=0&id=37f8493e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f8493e",
  null
  
)

export default component.exports